import React, { FC, PropsWithChildren, useCallback } from "react";
import { Modal } from "antd";

export interface DialogProps {
  title: string;

  visible: boolean;
  setVisible: (visible: boolean) => void;

  onOk?: () => void;
  onCancel?: () => void;
}

export const Dialog: FC<PropsWithChildren<DialogProps>> = ({
  title,
  visible,
  setVisible,
  children,
  onOk: _onOk,
  onCancel: _onCancel,
}) => {
  const onOk = useCallback(() => {
    setVisible(false);
    _onOk?.();
  }, [_onOk, setVisible]);

  const onCancel = useCallback(() => {
    setVisible(false);
    _onCancel?.();
  }, [_onCancel, setVisible]);

  return (
    <Modal
      centered
      title={title}
      open={visible}
      onCancel={onCancel}
      onOk={onOk}
    >
      {children}
    </Modal>
  );
};
